import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { ImProfile } from "react-icons/im";
import { RiUserSettingsFill } from "react-icons/ri";
import { CiEdit } from "react-icons/ci";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';  
import { getNames } from 'country-list'; 
import axios from 'axios';
import './account-settings.css';

function Settings() {
  const navigate = useNavigate();
  
  const countries = getNames().map(country => ({
    label: country,
    value: country,
  }));

  const pakistaniCities = [
    { label: 'Karachi', value: 'Karachi' },
    { label: 'Lahore', value: 'Lahore' },
    { label: 'Islamabad', value: 'Islamabad' },
    { label: 'Peshawar', value: 'Peshawar' },
    { label: 'Quetta', value: 'Quetta' },
    { label: 'Faisalabad', value: 'Faisalabad' },
    { label: 'Rawalpindi', value: 'Rawalpindi' },
    { label: 'Sialkot', value: 'Sialkot' },
  ];

  const [selectedCountry, setSelectedCountry] = useState({ label: 'Pakistan', value: 'Pakistan' });
  const [selectedCity, setSelectedCity] = useState(pakistaniCities[0]);
  const [user, setUser] = useState({
    name: '',
    email: '',
    phone: '',
    address: '',
    country: 'Pakistan',
    city: 'Karachi'
  });
  
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const userId = localStorage.getItem('userId');

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get(`https://backend.ems.hiradentallab.com/api/user/user/${userId}`);
        const fetchedUser = response.data;
        setUser({
          name: fetchedUser.name || '',
          email: fetchedUser.email || '',
          phone: fetchedUser.phone || '',
          address: fetchedUser.address || '',
          country: fetchedUser.country || 'Pakistan',
          city: fetchedUser.city || 'Karachi',
        });
        setSelectedCountry({ label: fetchedUser.country || 'Pakistan', value: fetchedUser.country || 'Pakistan' });
        setSelectedCity({ label: fetchedUser.city || 'Karachi', value: fetchedUser.city || 'Karachi' });
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, [userId]);

  const handleResetPasswordClick = () => {
    navigate('/reset-password');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Update user state with selected country and city
      const updatedUser = {
        ...user,
        country: selectedCountry.value,
        city: selectedCity.value
      };

      // Send JSON data via PUT request
      const response = await axios.put(`https://backend.ems.hiradentallab.com/api/user/update/${userId}`, updatedUser);

      // Check if update was successful
      if (response.status === 200) {
        setShowAlert(true);
        setAlertMessage('User data updated successfully!');
        setTimeout(() => {
          setShowAlert(false);
          navigate('/profile');
        }, 3000);
      }
    } catch (error) {
      console.error('Error updating user data:', error);
      setShowAlert(true);
      setAlertMessage('Error updating data. Please try again.');
      setTimeout(() => setShowAlert(false), 3000);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUser((prevUser) => ({ ...prevUser, [name]: value }));
  };

  const handleCountryChange = (selectedOption) => {
    setSelectedCountry(selectedOption);
  };

  const handleCityChange = (selectedOption) => {
    setSelectedCity(selectedOption);
  };

  return (
    <div className='container-settings'>
      <h1 className="settings-title">
        <ImProfile className="settings-icon" /> Profile
      </h1>
      <hr />
      <h1 className="settings-subtitle">
        <RiUserSettingsFill className="settings-icon" /> Settings
      </h1>
      <hr />
      {showAlert && (
        <div className="alert alert-success" role="alert">
          {alertMessage}
        </div>
      )}
      <div className="settings-container">
        <Form onSubmit={handleSubmit} className="settings-form">
          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={6} controlId="formGridName">
              <Form.Label>Name :</Form.Label>
              <Form.Control type="text" name="name" value={user.name || ''} onChange={handleChange} required placeholder="Enter Your Name" />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="formGridEmail">
              <Form.Label>E-mail :</Form.Label>
              <Form.Control type="email" name="email" value={user.email || ''} onChange={handleChange} required placeholder="Enter Your email" />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Col xs={12} md={6}>
              <Form.Group controlId="formGridPhone">
                <Form.Label>Phone :</Form.Label>
                <Form.Control type="tel" name="phone" value={user.phone || ''} onChange={handleChange} required placeholder="Enter Your phone no." />
              </Form.Group>
            </Col>

            <Col xs={12} md={6}>
              <Form.Group controlId="formGridCountry">
                <Form.Label>Country :</Form.Label>
                <Select
                  name="country"
                  options={countries}
                  value={selectedCountry}
                  onChange={handleCountryChange}
                  className="basic-single"
                  classNamePrefix="select"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={6} controlId="formGridCity">
              <Form.Label>City :</Form.Label>
              <Select
                name="city"
                options={pakistaniCities}
                value={selectedCity}
                onChange={handleCityChange}
                className="basic-single"
                classNamePrefix="select"
                required
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="formGridAddress">
              <Form.Label>Address :</Form.Label>
              <Form.Control type="text" name="address" value={user.address || ''} onChange={handleChange} required />
            </Form.Group>
          </Row>

          <div className="settings-actions">
            <Button variant="primary" type="submit" className="settings-btn">
              <CiEdit />
              Save
            </Button>

            <Button variant="primary" onClick={handleResetPasswordClick}>
              Reset Password
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
}

export default Settings;
